import React, { Component } from 'react';
import { Menu } from 'antd';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { SanityCheckContainer, StyledMenuItem, SanityCheckEntry } from './styled';

import iconNames from '../../constants/sanityCheck/icon-names';

@inject('dashboardStore')
@observer
class SanityCheck extends Component {
  render() {
    const {
      toggleSanityCheck,
      dashboardStore: { sanityChecks },
      open,
      mobileLayout,
    } = this.props;

    return (
      <SanityCheckContainer
        toggleSanityCheck={toggleSanityCheck}
        open={open}
        mobileLayout={mobileLayout}
      >
        <Menu
          mode="horizontal"
          css={{
            background: ' #ffffff',
            padding: 0,
            display: 'flex',
            flexDirection: mobileLayout ? 'column' : 'row',
            alignItems: 'stretch',
            justifyContent: 'space-around',
            height: '100%',
            maxWidth: '1248px',
            margin: '0 auto',
            borderBottom: 'none',
          }}
        >
          {sanityChecks
            .filter(check => check.sanityCheckId !== 'giftcard-availability')
            .map(sc => (
              <StyledMenuItem key={sc.sanityCheckId}>
                <SanityCheckEntry
                  title={sc.sanityCheckName}
                  icon={iconNames[sc.statusType]}
                  size={sc.statusType === 3 ? 22 : 16}
                  textMargin={sc.statusType === 3 ? '0.4em' : '1em'}
                />
              </StyledMenuItem>
            ))}
        </Menu>
      </SanityCheckContainer>
    );
  }
}
SanityCheck.propTypes = {
  toggleSanityCheck: PropTypes.func,
  open: PropTypes.bool,
  dashboardStore: PropTypes.object,
};
export default SanityCheck;
